import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'suedmetall',
} as IModuleProps;
